import './OIDCProviders.scss';

import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { createAsyncSelectors } from '@lib/selectors';
import { OidcProviderLoginButton } from './OidcProviderLoginButton';
import React from 'react';
import { securityActions } from '@sonar-software/sonar-security';
import { useAsyncStateWithPreload } from '@hooks';

const selectors = createAsyncSelectors((state) => state.security.oidcConfigurations.bySubdomain.get);

export const OidcProviders: React.FC = () => {
	const { data } = useAsyncStateWithPreload(
		selectors,
		securityActions.requestGetSecurityOidcConfigurationsBySubdomain,
		true
	);

	if (!data?.length) {
		return null;
	}

	return (
		<div id='oidc-providers'>
			<div className='subtext'>{ COPY_SPECIFIC.OR_LOGIN_USING }</div>
			<div className='providers'>{
				data.map((config) =>
					<OidcProviderLoginButton
						config={ config }
						key={ config.oidcClientID } />)
			}
			</div>
		</div>
	);
};
